import{useEffect,useRef}from"react";export function usePrevious(a){var b=useRef();return useEffect(()=>{b.current=a}),b.current}